import { useFormContext } from 'react-hook-form';
import { TextField as Input } from '@mui/material';

interface ITextFieldInputs {
  name: string;
  label: string;
  required?: boolean;

  /* onChange & value are only required if state has to be manually adjusted. Else, leave as undefined. */
  onChange?: (event: { target: { value: string } }) => void;
  value?: string;
}

export function EmailField(props: ITextFieldInputs) {
  const { name, label, onChange, value, required = false } = props;
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Input
      id={name}
      label={label}
      value={value}
      fullWidth
      autoComplete="off"
      minRows={3}
      error={Boolean(errors[name])}
      helperText={errors[name]?.message}
      {...register(name, {
        required: required && `${label} is required.`,
        onChange: e => onChange && onChange(e),
        pattern: {
          value:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          message: 'Email must be valid',
        },
      })}
    />
  );
}
